<template>
  <div>
    <v-dialog v-model="workerDialog" width="700">
      <NewWorker :worker="workerEdit" v-on:updated="workerUpdated($event)"></NewWorker>
    </v-dialog>

    <v-progress-circular v-if="loading" indeterminate ></v-progress-circular>
    <v-layout v-else row wrap>

    <v-flex xs11></v-flex>
    <v-flex  xs1>
      <v-icon @click="changeMode(1)"  :color="mode ==1 ? 'primary' : 'gray'" class="icon">toc</v-icon><!--    <v-icon>view_list</v-icon>-->
      <v-icon @click="changeMode(2)" :color="mode ==2 ? 'primary' : 'gray'" class="icon">view_quilt</v-icon>
    </v-flex>

      <v-flex xs12>
        <SearchSort v-on:sort="sort($event)" v-on:search="search($event)" />
      </v-flex>

      <v-flex xs12>
        <v-data-table item-key="guid" v-if="mode == 1" :headers="headers" :items="items" class="elevation-1" :loading="loading"
           no-data-text="Brak pracowników" :rows-per-page-items="pagination.rowsPerPageItems" :expand="false" :pagination.sync="pagination">

          <template v-slot:items="props">
            <tr :class="getActiveBriefcaseGuid(props.item) ? 'worker-open' : 'worker-close'" :key="props.item.id" @click="props.expanded = !props.expanded">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.surname }}</td>
              <td>{{ props.item.pesel }}</td>
              <td>{{ props.item.id_number }}</td>
              <td>
                <v-btn :disabled="!getActiveBriefcaseGuid(props.item)" @click="goToWorkersDocument(props.item)" small icon>
                  <v-icon color="green darken-3">pageview</v-icon>
                </v-btn>
                <v-btn @click="showWorkerBriefcases(props.item, $event)" small icon>
                  <v-icon color="brown darken-3">mdi-briefcase</v-icon>
                </v-btn>
                <v-btn  @click="edit(props.item)" small  icon>
                  <v-icon color="primary darken-3">mdi-pencil</v-icon>
                </v-btn>
                <v-btn v-if="!getActiveBriefcaseGuid(props.item)" @click="openBriefcase(props.item)" small icon>
                  <v-icon color="orange darken-3">lock_open</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:expand="props">
            <v-card>
              <v-container style="background-color: rgba(190,169,253,0.22)">
                <BriefcaseTable @closed="briefcaseClosed($event)" :worker="props.item"></BriefcaseTable>
              </v-container>
            </v-card>
          </template>

        </v-data-table>

        <v-dialog width="1000" v-model="dialogOpenBriefcase">
            <OpenBriefcase @briefcase-opened="briefcaseOpened" :worker="workerOpenBriefcase">
              <template v-slot:actions>
                <v-btn color="red darken-2" @click="dialogOpenBriefcase = false">Zamknij</v-btn>
              </template>
            </OpenBriefcase>
        </v-dialog>

        <v-dialog width="1000" v-model="dialogBriefcases">
          <v-sheet>
          <h2 style="text-align: center;padding: 1rem 1rem">
            Teczki
          </h2>
            <BriefcaseTable @closed="briefcaseClosed($event)" :worker="workerForBirefcases"></BriefcaseTable>
            <v-btn @click="dialogBriefcases = false">Zamknij</v-btn>
          </v-sheet>
        </v-dialog>


        <v-container fluid grid-list-lg>
        <v-data-iterator  no-data-text="Brak pracowników" v-if="mode == 2" :items="items"
                          :rows-per-page-items="rowsPerPageItems" content-tag="v-layout" row wrap>
          <template v-slot:item="props">
            <v-flex xs10 sm5 md4 lg4  style="margin-top: 1rem;">
              <DynamicCardView :titleKey="['name','surname']" :item="props.item" :translations="translations" :keys="keys" >
                <template v-slot:actions="item">
                  <v-btn color="green darken-1"  @click="goToWorkersDocument(props.item)"  >
                  Zobacz
                </v-btn>
                  <v-btn color="brown darken-1"  @click="showWorkerBriefcases(props.item)"  >
                    Teczki
                  </v-btn>
                </template>
              </DynamicCardView>
            </v-flex>
          </template>
        </v-data-iterator>
        </v-container>

      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import SearchSort from "@/components/common/SearchSort";
import ValueView from "@/components/related/value/ValueView";
import DynamicCardView from "@/components/common/DynamicCardView";
import NewWorker from "@/components/document/worker/NewWorker";
import BriefcaseTable from "@/components/document/worker/BriefcaseTable";
import OpenBriefcase from "@/components/document/worker/OpenBriefcase";
export default {
  name: "Workers",
  components:{
    BriefcaseTable,
    NewWorker,
    DynamicCardView,
    ValueView,
    SearchSort,
    OpenBriefcase
  },
  data(){
    return{
      dialogOpenBriefcase : false,
      workerOpenBriefcase : {},
      workerForBirefcases: [],
      dialogBriefcases : false,
      workerDialog: false,
      workerEdit:{},
      headers : [
        {text: 'Imie', value: 'name' },
        {text: 'Nazwisko', value: 'surname'},
        {text: 'Pesel', value: 'pesel'},
        {text: 'Nr dokumentu', value: 'id_number'},
        {text: 'Akcje'}
      ],
      pagination: this.$store.getters.pagination,
      definition : {},
      schema :{},
      items : [],
      allItems : [],
      loading : true,
      rowsPerPageItems : [3],
      mode : 1,
      translations :{
        name : "Imie",
        surname : "Nazwisko",
        pesel : "Pesel",
        id_number: "Numer dokumentu",
        created_at : "Utworzono"
      },
      keys : ['name','surname','pesel','id_number','created_at']
    }
},
  methods: {
    briefcaseClosed({worker, briefcaseGuid}){
      worker.briefcases.find(el => el.guid == briefcaseGuid).status = 0
    },
    briefcaseOpened(briefcase){
      this.workerOpenBriefcase.briefcases.push(briefcase)
      this.dialogOpenBriefcase = false
    },
    openBriefcase(worker){
      this.workerOpenBriefcase = worker
      this.dialogOpenBriefcase  = true
    },
    showWorkerBriefcases(worker, event){
      if(event){
        event.stopPropagation();
      }

      this.workerForBirefcases = worker
      this.dialogBriefcases = true
    },
    workerUpdated(worker){
      let model = this.allItems.find(e => e.guid == worker.guid)
      Object.assign(model, worker)
      this.workerDialog = false
    },
    edit(worker){
      this.workerEdit = worker
      this.workerDialog = true
    },
    changeMode(mode){
      this.mode = mode
    },
    getActiveBriefcaseGuid(worker){
      let briefcase =  worker.briefcases.find(el => el.status == 10)
      return briefcase != null  ? briefcase.guid : false
    },
    goToWorkersDocument(worker){
      let briefcaseGuid = this.getActiveBriefcaseGuid(worker)
      this.$router.push({name: 'documents-briefcase', params : {briefcaseGuid}})
    },
    sort(event) {
      this.items = this.sortItems(this.items, event.sort)
    },
    sortItems(items, method) {
      if (method == "" || method == undefined) {
        return items
      }
      items.sort((a, b) => a.surname.localeCompare(b.surname))

      if (method == "DESC") {
        items.reverse()
      }

      return items
    },
    search(event) {
      let phrase = event.search

      if (phrase == "") {
        this.items = this.sortItems(this.allItems, event.sort)
        return
      }

      let matchItems = []
      let regex = new RegExp('.*(' + phrase + ').*', "i");
      this.allItems.forEach(item => {

        for( let property in item ) {
          if (regex.test(item[property])) {
            matchItems.push(item)
            break
          }

        }
      })

      this.items = this.sortItems(matchItems, event.sort)
    },
    loadWorkers() {
      this.loading = true
      this.$http.get('document/workers').then(data =>{
        this.loading = false
        this.items = data.data
        this.allItems = data.data
      })
    },
    addWorker(worker){
      this.allItems.push(worker)
      this.items = this.allItems
    }
  },
  created() {
    this.loadWorkers()
  }
}
</script>

<style scoped>
.icon{
  cursor: pointer;
}
.worker-close{
  background-color: rgba(189, 112, 121, 0.2);
}
</style>